import { QRCodeCanvas } from 'qrcode.react';
import { Link } from '../api';

interface Props {
    link: Link;
    shortDomain: string;
    onClose: () => void;
}

const InlineQRCode = ({ link, shortDomain, onClose }: Props) => {
    const shortUrl = link.shortUrl ? `${shortDomain}/${link.shortUrl}` : `${shortDomain}/${link.slug}`;

    const downloadQR = () => {
        const canvas = document.getElementById(`qr-canvas-${link.slug}`) as HTMLCanvasElement;
        if (canvas) {
            const pngUrl = canvas.toDataURL('image/png');
            const downloadLink = document.createElement('a');
            downloadLink.href = pngUrl;
            downloadLink.download = `qrcode-${link.slug}.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    return (
        <div className="inline-panel inline-qr">
            <div className="inline-panel-header">
                <span className="inline-panel-title">📱 QR Code</span>
                <button className="ghost-button" onClick={onClose} aria-label="Close">✕</button>
            </div>
            <div className="inline-panel-body">
                <QRCodeCanvas
                    id={`qr-canvas-${link.slug}`}
                    value={shortUrl}
                    size={180}
                    level="H"
                    includeMargin={true}
                />
                <p className="inline-qr-url">{shortUrl}</p>
                <button className="primary small" onClick={downloadQR}>
                    Download PNG
                </button>
            </div>
        </div>
    );
};

export default InlineQRCode;
